import { IPage } from '../types/interfaces';

export const pageSectionsDummyData: IPage = {
  id: 1,
  name: 'homepage',
  sections: [
    {
      id: 2,
      name: 'banner',
      content: {
        title: { ar: 'RX', en: 'RX' },
        subtitle: { ar: '', en: '' },
        description: { ar: 'أداءٌ وشغف ببعدٍ فريد متوازن', en: 'POWERFUL PERFORMANCE AND PASSIONATE LUXURY' }
      },
      parent_type: 'App\\Models\\Page',
      parent_id: 1,
      section_id: null,
      type: 'text_with_video',
      order: 1,
      disabled: false,
      button_type: 'call',
      button_text: {
        en: 'learn more',
        ar: 'إعرف المزيد'
      },
      button_data: 'leearn',
      created_at: '2024-11-24T12:38:32.000000Z',
      updated_at: '2025-04-16T12:34:27.000000Z',
      media: [],
      video: {
        id: 2,
        url: 'https://api.dev.lexus.autoconnect.digital/storage/videos/cms_sections/1uJw6B8eaMWXVWbNiVGsKjUPTfWwtb8elmH5ZAtf.mp4',
        url_mobile: 'https://api.dev.lexus.autoconnect.digital/storage/videos/cms_sections/pAV5e3pQ4esxHukWDDBbypfS1RnAD4OmDm48wvIz.mp4',
        poster_url: 'https://api.dev.lexus.autoconnect.digital/storage/videos/posters/cms_sections/2meVJtboEGUdcxVxy57ragx3OaJQQyVGVUEYlE3s.png',
        poster_mobile_url: 'https://api.dev.lexus.autoconnect.digital/storage/videos/posters/cms_sections/xErwdGPFv9mARWMxpB3h6Nkr3wnBBXYkcDiO1lfe.png'
      },
      has_relation: 1,
      model_type: 'interior_colors',
      model_data: [
        { id: 90, model_id: 19, order: 1 },
        { id: 91, model_id: 24, order: 2 }
      ],
      sub_sections: [
        {
          id: 2677,
          name: 'rx',
          content: {
            title: { ar: 'RX', en: 'RX' },
            subtitle: { ar: '', en: '' },
            description: { ar: 'أداءٌ وشغف ببعدٍ فريد متوازن', en: 'POWERFUL PERFORMANCE AND PASSIONATE LUXURY' }
          },
          parent_type: null,
          parent_id: null,
          section_id: 2,
          type: 'text_with_video',
          order: 1,
          disabled: false,
          button_type: 'url',
          button_text: {
            en: 'learn more',
            ar: 'إعرف المزيد'
          },
          button_data: '/models/rx-2',
          created_at: '2025-01-13T10:09:45.000000Z',
          updated_at: '2025-04-16T15:27:09.000000Z',
          media: [],
          video: {
            id: 32,
            url: 'https://api.dev.lexus.autoconnect.digital/storage/videos/cms_sections/sZx3r5e43JZXQu3uYoiKEDUrCEkRmn46t1im2Od5.mp4',
            url_mobile: 'https://api.dev.lexus.autoconnect.digital/storage/videos/cms_sections/CVXqgQEWul37mqcfNOsH95RICjSM02xYZC73jDkt.mp4',
            poster_url: 'https://api.dev.lexus.autoconnect.digital/storage/videos/posters/cms_sections/sMEkGVT88QLyXmXuOEiAo9YwSslSfON4ekzto0Vp.png',
            poster_mobile_url: 'https://api.dev.lexus.autoconnect.digital/storage/videos/posters/cms_sections/Kr3dNxz0sgOHei7HrBsXQ79PX6Ysf2AvKL1ealzl.png'
          },
          sub_sections: [],
          sections: []
        },
        {
          id: 2865,
          name: 'lx',
          content: { title: { ar: 'LX', en: 'LX' }, subtitle: { ar: '', en: '' }, description: { ar: 'قوة وحضور مُهيب', en: 'LIMITLESS POWER' } },
          parent_type: null,
          parent_id: null,
          section_id: 2,
          type: 'text_with_image',
          order: 2,
          disabled: false,
          button_type: 'url',
          button_text: {
            en: 'learn more',
            ar: 'إعرف المزيد'
          },
          button_data: '/models/lx',
          created_at: '2025-01-28T09:27:32.000000Z',
          updated_at: '2025-04-16T15:27:09.000000Z',
          media: [
            {
              id: 1799,
              url: 'https://api.dev.lexus.autoconnect.digital/storage/images/cms_sections/MBDnUZSl9EbBC435bmCQMVrF39YpdhLOuKz1TsId.webp',
              url_mobile: 'https://api.dev.lexus.autoconnect.digital/storage/images/cms_sections/7oW6wiwwjT7StJjGmFp8H75kG1lILE577kjVJUgw.webp',
              icon: null
            }
          ],
          video: null,
          sub_sections: [],
          sections: []
        },
        {
          id: 2871,
          name: 'lc',
          content: { title: { ar: 'LC', en: 'LC' }, subtitle: { ar: '', en: '' }, description: { ar: 'الإتقان والسرعة', en: 'Speed Perfected' } },
          parent_type: null,
          parent_id: null,
          section_id: 2,
          type: 'text_with_video',
          order: 3,
          disabled: false,
          button_type: 'url',
          button_text: {
            en: 'learn more',
            ar: 'إعرف المزيد'
          },
          button_data: '/models/lc',
          created_at: '2025-01-28T10:31:55.000000Z',
          updated_at: '2025-04-16T15:27:09.000000Z',
          media: [],
          video: {
            id: 54,
            url: 'https://api.dev.lexus.autoconnect.digital/storage/videos/cms_sections/VMVhXGm7JoiV3lm2lI8KGWl9h9dTUDEhefkZbRRW.mp4',
            url_mobile: 'https://api.dev.lexus.autoconnect.digital/storage/videos/cms_sections/e0i2XSzo14Di3XJEgr6Yqlj0FvaEt1YuN9S7oFxe.mp4',
            poster_url: 'https://api.dev.lexus.autoconnect.digital/storage/videos/posters/cms_sections/NxDr6GJFnd5IoKabmXUBA1rYPAnnJgqpnuQxibM6.jpg',
            poster_mobile_url: 'https://api.dev.lexus.autoconnect.digital/storage/videos/posters/cms_sections/QAPQ5E8HZ33aMz1HEFc6Yo0t0kGeb84fLOTSYIRr.jpg'
          },
          sub_sections: [],
          sections: []
        },
        {
          id: 2872,
          name: 'nx',
          content: { title: { ar: 'NX', en: 'NX' }, subtitle: { ar: '', en: '' }, description: { ar: 'روعةٌ في الأداء', en: 'Elegant Motion' } },
          parent_type: null,
          parent_id: null,
          section_id: 2,
          type: 'text_with_image',
          order: 4,
          disabled: false,
          button_type: 'url',
          button_text: {
            en: 'learn more',
            ar: 'إعرف المزيد'
          },
          button_data: '/models/nx-2',
          created_at: '2025-01-28T10:35:39.000000Z',
          updated_at: '2025-04-16T15:27:09.000000Z',
          media: [
            {
              id: 1807,
              url: 'https://api.dev.lexus.autoconnect.digital/storage/images/cms_sections/LZjggeA6WBAY8NaYP6VNcbwzlzyGPTl1BGxNx0US.webp',
              url_mobile: 'https://api.dev.lexus.autoconnect.digital/storage/images/cms_sections/wqJ82tDCH5wGixshTwy1dShaojR0aBXEWpUNAVuY.webp',
              icon: null
            }
          ],
          video: null,
          sub_sections: [],
          sections: []
        }
      ]
    },
    {
      id: 29,
      name: 'meet-our-latest-range',
      content: { title: { ar: 'تعرف على أحدث تشكيلاتنا', en: 'meet our latest range' }, subtitle: { ar: '', en: '' }, description: { ar: '', en: '' } },
      parent_type: 'App\\Models\\Page',
      parent_id: 1,
      section_id: null,
      type: 'text',
      order: 2,
      disabled: false,
      button_type: null,
      button_text: {
        en: '',
        ar: ''
      },
      button_data: null,
      created_at: '2024-12-10T08:29:01.000000Z',
      updated_at: '2025-02-09T11:26:09.000000Z',
      media: [],
      video: null,
      sub_sections: []
    },
    {
      id: 23,
      name: 'services',
      content: {
        title: {
          ar: 'اختبر الرعاية المتخصصة مع لكزس، لضمان بقاء سيارتك في أفضل حالة في كل مرة.',
          en: 'Experience expert care with Lexus, ensuring your vehicle remains in top condition every time.'
        },
        subtitle: { ar: '', en: '' },
        description: { ar: '', en: '' }
      },
      parent_type: 'App\\Models\\Page',
      parent_id: 1,
      section_id: null,
      type: 'text',
      order: 5,
      disabled: false,
      button_type: null,
      button_text: {
        en: '',
        ar: ''
      },
      button_data: null,
      created_at: '2024-12-09T08:35:43.000000Z',
      updated_at: '2025-02-09T11:26:09.000000Z',
      media: [],
      video: null,
      sub_sections: [
        {
          id: 24,
          name: 'book-a-service',
          content: {
            title: { ar: 'احجز موعد خدمتك', en: 'Book A Service' },
            subtitle: { ar: '', en: '' },
            description: {
              ar: 'يظلّ أثر الجودة العالية ثابتًا في الأذهان مدّة تطول وتطغى على السعر الذي دُفِع بها؛ فاحرص على حماية استثمارك الثمين من خلال حجز موعدٍ في مركز لكزس المعتمد. نلتزم في لكزس بتطبيق مبدأ القيمة مقابل المال؛ فنسعى لبذل كلّ جهودنا في مركز الخدمة للحفاظ على جوهر فخامة سيارة لكزس.',
              en: "After investing in a Lexus, it's important to protect your investment by only entrusting the service of your vehicle to Lexus Service Center"
            }
          },
          parent_type: null,
          parent_id: null,
          section_id: 23,
          type: 'text_with_image_and_icon',
          order: 1,
          disabled: false,
          button_type: 'url',
          button_text: {
            en: 'Book Now',
            ar: 'إحجز الأن'
          },
          button_data: null,
          created_at: '2024-12-09T08:51:16.000000Z',
          updated_at: '2025-02-09T11:26:09.000000Z',
          media: [
            {
              id: 298,
              url: 'https://api.dev.lexus.autoconnect.digital/storage/images/cms_sections/I6KuF4gWAZCnwhPsiPJh7wX72tcakh1GrIpViJDw.webp',
              url_mobile: 'https://api.dev.lexus.autoconnect.digital/storage/images/cms_sections/jBJ9KHPMBTRxiNJfzGT8R7ZgjH1mmoDinHLVxBcA.webp',
              icon: 'https://api.dev.lexus.autoconnect.digital/storage/images/cms_sections/qDmDxhAb60gu3UWApwp6BuIwOsqCkG3jAscch9Wt.png'
            }
          ],
          video: null,
          sub_sections: [],
          sections: []
        },
        {
          id: 25,
          name: 'lexus-connect-service',
          content: {
            title: { ar: 'خدمات لكزس المتكاملة', en: 'Lexus Connect Services' },
            subtitle: { ar: '', en: '' },
            description: {
              ar: 'تمتّع بسهولة الوصول لسيارتك وإعداداتها بتواصلٍ سلس ومتكامل من خلال الاستفادة من مِيزات تطبيق خدمات لكزس المتكاملة. لتفاصيل أكثر، يُرجى مشاهدة الفيديو.',
              en: 'Discover the sheer joy of effortless accessibility and seamless connectivity with your vehicle, courtesy of the incredible features packed into the Lexus Connected App. Watch the video for details.'
            }
          },
          parent_type: null,
          parent_id: null,
          section_id: 23,
          type: 'text_with_image_and_icon',
          order: 2,
          disabled: false,
          button_type: 'url',
          button_text: {
            en: 'learn more',
            ar: 'إعرف المزيد'
          },
          button_data: '/services/lexus-connect',
          created_at: '2024-12-09T08:51:16.000000Z',
          updated_at: '2025-02-09T11:26:09.000000Z',
          media: [
            {
              id: 303,
              url: 'https://api.dev.lexus.autoconnect.digital/storage/images/cms_sections/jkWRyiFX4UuRAMKahUNOl2OOYNIQtDTRgFLvBaLM.webp',
              url_mobile: 'https://api.dev.lexus.autoconnect.digital/storage/images/cms_sections/RnJpyv0EL7xtz9fzmATlaCxGhgnplryrXUUKiaJd.webp',
              icon: 'https://api.dev.lexus.autoconnect.digital/storage/images/cms_sections/CQ6oeTgJKHLyNwXX5hpY3qedCfT3PfCwLGLPtP4Z.png'
            }
          ],
          video: null,
          sub_sections: [],
          sections: []
        },
        {
          id: 26,
          name: 'special-service',
          content: {
            title: { ar: 'الخدمات المميزة', en: 'Special Service' },
            subtitle: { ar: '', en: '' },
            description: {
              ar: 'شغفنا هو ان نقدم لك تجربة ملكية ممتازة . نحن نشارك عملائنا المتعة التي يحصلون عليها من امتلاك و قيادة سيارة لكزس.',
              en: 'Our passion is providing you with an excellent ownership experience. We share the thrill our customers get from owning and driving a Lexus.'
            }
          },
          parent_type: null,
          parent_id: null,
          section_id: 23,
          type: 'text_with_image_and_icon',
          order: 3,
          disabled: false,
          button_type: 'url',
          button_text: {
            en: 'learn more',
            ar: 'إعرف المزيد'
          },
          button_data: '/services/special-service',
          created_at: '2024-12-09T08:51:16.000000Z',
          updated_at: '2025-02-09T11:26:09.000000Z',
          media: [
            {
              id: 304,
              url: 'https://api.dev.lexus.autoconnect.digital/storage/images/cms_sections/KNXeMgxA5JzruwdgGYqX7N0Xdkl9Aq6lbapPUUO8.webp',
              url_mobile: 'https://api.dev.lexus.autoconnect.digital/storage/images/cms_sections/i5mBTgQVOiDx2OmfvO1jr80FwxjGnhakZU3t6eiL.webp',
              icon: 'https://api.dev.lexus.autoconnect.digital/storage/images/cms_sections/6K4BlNhUJELRvFq6incsqBDLpU52OQkdGhdH86p5.png'
            }
          ],
          video: null,
          sub_sections: [],
          sections: []
        },
        {
          id: 27,
          name: 'service-your-lexus',
          content: {
            title: { ar: 'خدمة سيارات لكزس', en: 'Service Your Lexus' },
            subtitle: { ar: '', en: '' },
            description: {
              ar: 'قم بعمل الصيانة الدورية لسيارتك على أيدي فريق من المحترفين الذين سوف يقدمون خدمة مخصصة لسيارتك بكامل الدقة و الاهتمام لجميع تفاصيل العمل في مركز لكزس.',
              en: "Allow us to elevate your driving experience through our meticulously crafted Periodic Maintenance service. Our team provides bespoke care. Every aspect of your vehicle's upkeep reflects reliability and fine craftsmanship, ensuring each drive in your Lexus is amazing."
            }
          },
          parent_type: null,
          parent_id: null,
          section_id: 23,
          type: 'text_with_image_and_icon',
          order: 4,
          disabled: false,
          button_type: 'url',
          button_text: {
            en: 'learn more',
            ar: 'إعرف المزيد'
          },
          button_data: '/services/service-your-lexus',
          created_at: '2024-12-09T08:51:16.000000Z',
          updated_at: '2025-02-09T11:26:09.000000Z',
          media: [
            {
              id: 305,
              url: 'https://api.dev.lexus.autoconnect.digital/storage/images/cms_sections/R66uz7h5W4syyvBGNpbXqvS4nhT2Sf0BpCritQhp.jpg',
              url_mobile: 'https://api.dev.lexus.autoconnect.digital/storage/images/cms_sections/ZOOAJNOh9h42LNkdDvktMXq7GkQC8LFKNfe5vR5R.jpg',
              icon: 'https://api.dev.lexus.autoconnect.digital/storage/images/cms_sections/EaFMLPU1UguYEl1q5nF4IV7yLXR8egf9LRnBKLuf.png'
            }
          ],
          video: null,
          sub_sections: [],
          sections: []
        },
        {
          id: 28,
          name: 'warranty',
          content: {
            title: { ar: 'الضمانة', en: 'Warranty' },
            subtitle: { ar: '', en: '' },
            description: {
              ar: 'انطلق في سيارة لكزس، في رحلةٍ تَفيضُ بالبهجة والحماسة، مدعومًا بضمانٍ يتناغم مع احتياجاتك المتغيرة، لتزدان كلّ لحظةٍ فيها بالمتعة والراحة دون متاعب تُقلِق راحة بالك. يٌعدُّ الضمان بمثابة درعٍ يُتيح لك الانطلاق في الطريق بكل حريّة وطموح، وبثقةٍ راسخة ودعمٍ لا محدود.',
              en: 'Driving a Lexus should be an experience of joy and exhilaration, without worries.'
            }
          },
          parent_type: null,
          parent_id: null,
          section_id: 23,
          type: 'text_with_image_and_icon',
          order: 5,
          disabled: false,
          button_type: 'url',
          button_text: {
            en: 'learn more',
            ar: 'إعرف المزيد'
          },
          button_data: 'services/warranty',
          created_at: '2024-12-09T08:51:16.000000Z',
          updated_at: '2025-02-09T11:26:09.000000Z',
          media: [
            {
              id: 306,
              url: 'https://api.dev.lexus.autoconnect.digital/storage/images/cms_sections/ZGHPRkPX0mnX0A0i4N4MIKbfGqeKbwWrUerUqWYS.webp',
              url_mobile: 'https://api.dev.lexus.autoconnect.digital/storage/images/cms_sections/36CUzmzbWClozzFFerhghr0HGeNA64Zn2879ggSJ.webp',
              icon: 'https://api.dev.lexus.autoconnect.digital/storage/images/cms_sections/ejGSdG9mTOTA9ObLVNM3wnBKIC6rZ12NnuRy5heg.png'
            }
          ],
          video: null,
          sub_sections: [],
          sections: []
        }
      ]
    },
    {
      id: 2724,
      name: 'showroom',
      content: { title: { ar: '', en: 'find a showroom' }, subtitle: { ar: '', en: '' }, description: { ar: '', en: '' } },
      parent_type: 'App\\Models\\Page',
      parent_id: 1,
      section_id: null,
      type: 'text_with_image',
      order: 6,
      disabled: false,
      button_type: null,
      button_text: {
        en: '',
        ar: ''
      },
      button_data: null,
      created_at: '2025-01-15T13:19:09.000000Z',
      updated_at: '2025-02-09T11:26:09.000000Z',
      media: [
        {
          id: 733,
          url: 'https://api.dev.lexus.autoconnect.digital/storage/images/cms_sections/xLxBrMHxRP9zyP6UHbs1sgi9wyyFVOsUf7yiJfLx.png',
          url_mobile: 'https://api.dev.lexus.autoconnect.digital/storage/images/cms_sections/10rzhYhrEwhrbChEy0cABp5KreFHBtwIORlfX4xI.png',
          icon: null
        }
      ],
      video: null,
      sub_sections: []
    },
    {
      id: 2930,
      name: 'seo',
      content: {
        title: { ar: 'Lexus Car Dealer | Al Sayer Lexus', en: 'Lexus Car Dealer | Al Sayer Lexus' },
        subtitle: { ar: '', en: '' },
        description: {
          ar: 'Visit Al Sayer Lexus, established dealership and servicing specialist. Explore our website to browse through our stock and discover our full range of offers. Get in touch today to discover the benefits we provide and book a test drive.',
          en: 'Visit Al Sayer Lexus, established dealership and servicing specialist. Explore our website to browse through our stock and discover our full range of offers. Get in touch today to discover the benefits we provide and book a test drive.'
        }
      },
      parent_type: 'App\\Models\\Page',
      parent_id: 1,
      section_id: null,
      type: 'text_with_image',
      order: 7,
      disabled: false,
      button_type: null,
      button_text: {
        en: '',
        ar: ''
      },
      button_data: null,
      created_at: '2025-02-09T11:26:09.000000Z',
      updated_at: '2025-02-09T11:26:09.000000Z',
      media: [
        {
          id: 2104,
          url: 'https://api.dev.lexus.autoconnect.digital/storage/images/cms_sections/HfmyVZp5jh1jKI5104dt1S44Z7r9TFi0IxLFoF42.png',
          url_mobile: 'https://api.dev.lexus.autoconnect.digital/storage/images/cms_sections/Kp05YJGyc6uia7aQCtvM10EedQUbm93WvqKZmgzy.png',
          icon: null
        }
      ],
      video: null,
      sub_sections: []
    }
  ]
};

export const exteriorSelect = {
  code: 200,
  errors: [],
  data: [
    {
      value: 17,
      label: 'White Nova Glass Flake',
      circle_image: 'jbrruvk2eWeZdixhpRZVfhn8T7NZ8cLxArALl3Xd.webp',
      circle_image_path: 'https://api.dev.lexus.autoconnect.digital/storage/images/color-wheel-bases/circles/jbrruvk2eWeZdixhpRZVfhn8T7NZ8cLxArALl3Xd.webp',
      vehicles_count: 7
    },
    {
      value: 18,
      label: 'Sonic Quartz',
      circle_image: 'YBOtSUuGnLAXrabucUhbSUDjyBtaqSUchb0GJtbs.png',
      circle_image_path: 'https://api.dev.lexus.autoconnect.digital/storage/images/color-wheel-bases/circles/YBOtSUuGnLAXrabucUhbSUDjyBtaqSUchb0GJtbs.png',
      vehicles_count: 93
    },
    {
      value: 49,
      label: 'Red MC. CS.',
      circle_image: null,
      circle_image_path: 'https://api.dev.lexus.autoconnect.digital/storage/images/color-wheel-bases/circles',
      vehicles_count: 8
    },
    {
      value: 63,
      label: 'Ice Ecru Mica Metallic',
      circle_image: 'RQ4eaAkfwyNxVIUJffIHDLvP3vPV0Cv4ICgexgWU.png',
      circle_image_path: 'https://api.dev.lexus.autoconnect.digital/storage/images/color-wheel-bases/circles/RQ4eaAkfwyNxVIUJffIHDLvP3vPV0Cv4ICgexgWU.png',
      vehicles_count: 23
    },
    {
      value: 118,
      label: 'Sonic Iridium',
      circle_image: 'p8cYmsHpoAFWbzquO1h0khOuhhCdkzIEp98pYmtU.png',
      circle_image_path: 'https://api.dev.lexus.autoconnect.digital/storage/images/color-wheel-bases/circles/p8cYmsHpoAFWbzquO1h0khOuhhCdkzIEp98pYmtU.png',
      vehicles_count: 5
    },
    {
      value: 134,
      label: 'Sonic Titanium',
      circle_image: '3drAiEqBW1Vv0BmyAKWyDYLwwB13Sxz7r5ESmdr3.png',
      circle_image_path: 'https://api.dev.lexus.autoconnect.digital/storage/images/color-wheel-bases/circles/3drAiEqBW1Vv0BmyAKWyDYLwwB13Sxz7r5ESmdr3.png',
      vehicles_count: 95
    },
    {
      value: 135,
      label: 'رمادي',
      circle_image: 'yByAVpZcecsgw6QjUNagUvi9ATuRu9BaSp6iEAGq.png',
      circle_image_path: 'https://api.dev.lexus.autoconnect.digital/storage/images/color-wheel-bases/circles/yByAVpZcecsgw6QjUNagUvi9ATuRu9BaSp6iEAGq.png',
      vehicles_count: 1
    },
    {
      value: 137,
      label: 'Sonic Chrome',
      circle_image: 'EaDu4T8pzDCzM2Rl3i5T2tQ6tRins621YuyD5zPC.png',
      circle_image_path: 'https://api.dev.lexus.autoconnect.digital/storage/images/color-wheel-bases/circles/EaDu4T8pzDCzM2Rl3i5T2tQ6tRins621YuyD5zPC.png',
      vehicles_count: 54
    },
    {
      value: 138,
      label: 'رمادي',
      circle_image: null,
      circle_image_path: 'https://api.dev.lexus.autoconnect.digital/storage/images/color-wheel-bases/circles',
      vehicles_count: 1
    },
    {
      value: 209,
      label: 'أسود',
      circle_image: 'SfFvRJiLVglGS0dVpmTh0sXE8EgeVuRWLEDmaJ6P.png',
      circle_image_path: 'https://api.dev.lexus.autoconnect.digital/storage/images/color-wheel-bases/circles/SfFvRJiLVglGS0dVpmTh0sXE8EgeVuRWLEDmaJ6P.png',
      vehicles_count: 89
    },
    {
      value: 249,
      label: 'أخضر فاتح',
      circle_image: null,
      circle_image_path: 'https://api.dev.lexus.autoconnect.digital/storage/images/color-wheel-bases/circles',
      vehicles_count: 3
    },
    {
      value: 274,
      label: 'Deep Blue Mica',
      circle_image: null,
      circle_image_path: 'https://api.dev.lexus.autoconnect.digital/storage/images/color-wheel-bases/circles',
      vehicles_count: 5
    }
  ],
  message: 'Success ',
  meta: []
};

export const interiorSelect = {
  code: 200,
  errors: [],
  data: [
    {
      value: 19,
      label: 'عنابي',
      circle_image_path: 'https://api.dev.lexus.autoconnect.digital/storage/images/trim-cab-types/circles/iRMDCIhUNVK4ZrT4gXpmcU95sRSJl1X7ydnMMDa5.png',
      vehicles_count: 1
    },
    {
      value: 24,
      label: 'FLARE Red',
      circle_image_path: 'https://api.dev.lexus.autoconnect.digital/storage/images/trim-cab-types/circles',
      vehicles_count: 2
    },
    {
      value: 25,
      label: 'تان',
      circle_image_path: 'https://api.dev.lexus.autoconnect.digital/storage/images/trim-cab-types/circles/LNwDfR7hhHx3yyJexEa1jf4pEFgMy8CmGImEiNZ8.png',
      vehicles_count: 77
    },
    {
      value: 26,
      label: 'Black Ocher',
      circle_image_path: 'https://api.dev.lexus.autoconnect.digital/storage/images/trim-cab-types/circles/JtBA8qpXrJ8Rn3mDCQNi20e6bpLjBD8qcqwGbDJ3.jpg',
      vehicles_count: 36
    },
    {
      value: 27,
      label: 'تان',
      circle_image_path: 'https://api.dev.lexus.autoconnect.digital/storage/images/trim-cab-types/circles',
      vehicles_count: 9
    },
    {
      value: 49,
      label: 'BLACK',
      circle_image_path: 'https://api.dev.lexus.autoconnect.digital/storage/images/trim-cab-types/circles',
      vehicles_count: 4
    },
    {
      value: 54,
      label: 'بيج',
      circle_image_path: 'https://api.dev.lexus.autoconnect.digital/storage/images/trim-cab-types/circles',
      vehicles_count: 3
    },
    {
      value: 57,
      label: 'Flare Red',
      circle_image_path: 'https://api.dev.lexus.autoconnect.digital/storage/images/trim-cab-types/circles',
      vehicles_count: 22
    },
    {
      value: 61,
      label: 'Ocher',
      circle_image_path: 'https://api.dev.lexus.autoconnect.digital/storage/images/trim-cab-types/circles/GDg88ow6KrWghwMYifRoqThV7s4vTzvy6ozGM9yb.png',
      vehicles_count: 131
    },
    {
      value: 63,
      label: 'Hazel',
      circle_image_path: 'https://api.dev.lexus.autoconnect.digital/storage/images/trim-cab-types/circles/urafP4VeYutWp3Uql1CIo5Jm8bptooyv3EtHLpgc.png',
      vehicles_count: 2
    },
    {
      value: 64,
      label: 'Dark Rose',
      circle_image_path: 'https://api.dev.lexus.autoconnect.digital/storage/images/trim-cab-types/circles/ZQ3FKX0eA96x48ZWVxR1rry022QkUAQeQLRHpuQw.png',
      vehicles_count: 10
    },
    {
      value: 65,
      label: 'Dark Sepia',
      circle_image_path: 'https://api.dev.lexus.autoconnect.digital/storage/images/trim-cab-types/circles/4iI3ryirAv8oeIQidsRc9Q2QvH6LRw1aDWZ4g9wT.png',
      vehicles_count: 87
    }
  ],
  message: 'Success ',
  meta: []
};

export const modelsSelect = {
  code: 200,
  errors: [],
  data: [
    {
      value: 68,
      label: 'RX',
      slug: 'rx-2',
      order: 2,
      vehicles_count: 175
    },
    {
      value: 69,
      label: 'NX',
      slug: 'nx-2',
      order: 0,
      vehicles_count: 46
    },
    {
      value: 70,
      label: 'ES',
      slug: 'es-2',
      order: 0,
      vehicles_count: 130
    },
    {
      value: 72,
      label: 'LC',
      slug: 'lc',
      order: 3,
      vehicles_count: 1
    },
    {
      value: 73,
      label: 'RC',
      slug: 'rc-2',
      order: 0,
      vehicles_count: 10
    },
    {
      value: 75,
      label: 'IS',
      slug: 'is',
      order: 0,
      vehicles_count: 3
    },
    {
      value: 76,
      label: 'UX',
      slug: 'ux',
      order: 0,
      vehicles_count: 13
    },
    {
      value: 78,
      label: 'LX',
      slug: 'lx',
      order: 1,
      vehicles_count: 4
    }
  ],
  message: 'Success ',
  meta: []
};

export const variantsSelect = {
  code: 200,
  errors: [],
  data: {
    RX500: [
      {
        value: 81,
        label: '23RX500H-F SPORT',
        vehicles_count: 2
      }
    ],
    LC500: [
      {
        value: 91,
        label: '24LC500-GLASSROOF',
        vehicles_count: 1
      }
    ],
    ES250: [
      {
        value: 94,
        label: '24ES250-PREMIER',
        vehicles_count: 14
      },
      {
        value: 163,
        label: '24ES250-LUXURY',
        vehicles_count: 2
      },
      {
        value: 182,
        label: '',
        vehicles_count: 20
      },
      {
        value: 183,
        label: '',
        vehicles_count: 27
      }
    ],
    ES350: [
      {
        value: 95,
        label: '24ES350-F SPORT',
        vehicles_count: 1
      },
      {
        value: 96,
        label: '24ES350-LUXURY',
        vehicles_count: 1
      },
      {
        value: 97,
        label: '24ES350-PREMIER',
        vehicles_count: 5
      },
      {
        value: 185,
        label: '',
        vehicles_count: 1
      },
      {
        value: 186,
        label: '',
        vehicles_count: 3
      },
      {
        value: 187,
        label: '',
        vehicles_count: 24
      },
      {
        value: 188,
        label: '',
        vehicles_count: 30
      },
      {
        value: 189,
        label: '',
        vehicles_count: 1
      }
    ],
    RC350: [
      {
        value: 100,
        label: '24RC350-LUXURY',
        vehicles_count: 3
      },
      {
        value: 101,
        label: '24RC350-F SPORT',
        vehicles_count: 2
      }
    ],
    NX350H: [
      {
        value: 103,
        label: '24NX350H-PREMIER',
        vehicles_count: 1
      },
      {
        value: 172,
        label: 'Nx350h PREMIER',
        vehicles_count: 15
      }
    ],
    IS300: [
      {
        value: 104,
        label: '24IS300-LUXURY',
        vehicles_count: 3
      }
    ],
    RX350: [
      {
        value: 134,
        label: '23RX350H-EXECUTIVE',
        vehicles_count: 2
      },
      {
        value: 145,
        label: '24RX350-PREMIER',
        vehicles_count: 1
      },
      {
        value: 146,
        label: '24RX350-LUXURY+',
        vehicles_count: 8
      },
      {
        value: 147,
        label: '24RX350-F SPORT',
        vehicles_count: 1
      },
      {
        value: 149,
        label: '24RX350-EXECUTIVE',
        vehicles_count: 13
      },
      {
        value: 199,
        label: '',
        vehicles_count: 4
      },
      {
        value: 200,
        label: '',
        vehicles_count: 6
      },
      {
        value: 201,
        label: '',
        vehicles_count: 1
      },
      {
        value: 202,
        label: '',
        vehicles_count: 57
      },
      {
        value: 203,
        label: '',
        vehicles_count: 67
      }
    ],
    UX300H: [
      {
        value: 138,
        label: '24UX300H-PREMIER',
        vehicles_count: 5
      },
      {
        value: 139,
        label: '24UX300H-LUXURY',
        vehicles_count: 4
      },
      {
        value: 140,
        label: '24UX300H-F SPORT',
        vehicles_count: 4
      }
    ],
    RX350H: [
      {
        value: 150,
        label: '24RX350H-PREMIER',
        vehicles_count: 4
      },
      {
        value: 151,
        label: '24RX350H-LUXURY',
        vehicles_count: 2
      },
      {
        value: 204,
        label: '',
        vehicles_count: 4
      },
      {
        value: 205,
        label: '',
        vehicles_count: 3
      }
    ],
    RC300: [
      {
        value: 165,
        label: '24RC300-PREMIER',
        vehicles_count: 5
      }
    ],
    NX350: [
      {
        value: 170,
        label: 'LUXURY',
        vehicles_count: 16
      },
      {
        value: 171,
        label: 'PREMIER',
        vehicles_count: 14
      }
    ],
    ES300H: [
      {
        value: 184,
        label: '',
        vehicles_count: 1
      }
    ],
    LS350: [
      {
        value: 190,
        label: '',
        vehicles_count: 1
      }
    ],
    LS500: [
      {
        value: 192,
        label: '',
        vehicles_count: 1
      }
    ],
    LX700H: [
      {
        value: 198,
        label: '',
        vehicles_count: 4
      }
    ]
  },
  message: 'Success ',
  meta: []
};

export const vehiclesSelect = {
  code: 200,
  errors: [],
  data: [
    {
      value: 1252,
      label: ' - JTJPBBCX7P4032263'
    },
    {
      value: 2129,
      label: 'Lexus LS350 2022 - JTHB41FF1N5004226'
    },
    {
      value: 2134,
      label: 'Lexus ES250 2023 - JTHB11B15P2055493'
    },
    {
      value: 2136,
      label: 'Lexus ES250 2023 - JTHB11B19P2057442'
    },
    {
      value: 2137,
      label: 'Lexus ES250 2023 - JTHB11B17P2057116'
    },
    {
      value: 2138,
      label: 'Lexus ES250 2023 - JTHB11B13P2056917'
    },
    {
      value: 2139,
      label: 'Lexus ES250 2023 - JTHB11B10P2056678'
    },
    {
      value: 2140,
      label: 'Lexus ES250 2023 - JTHB11B11P2056236'
    },
    {
      value: 2141,
      label: 'Lexus ES250 2023 - JTHB11B12P2057802'
    },
    {
      value: 2142,
      label: 'Lexus ES250 2023 - JTHB11B11P2058021'
    },
    {
      value: 2143,
      label: 'Lexus ES250 2023 - JTHB11B19P2051964'
    },
    {
      value: 2144,
      label: 'Lexus ES250 2023 - JTHB11B13P2058022'
    },
    {
      value: 2145,
      label: 'Lexus ES250 2023 - JTHB11B13P2057887'
    },
    {
      value: 2146,
      label: 'Lexus ES250 2023 - JTHB11B1XP2055831'
    },
    {
      value: 2147,
      label: 'Lexus ES250 2023 - JTHB11B12P2054429'
    },
    {
      value: 2148,
      label: 'Lexus ES250 2023 - JTHB11B19P2058025'
    },
    {
      value: 2149,
      label: 'Lexus ES250 2023 - JTHB11B15P2051749'
    },
    {
      value: 2150,
      label: 'Lexus ES250 2023 - JTHB11B15P2057809'
    },
    {
      value: 2151,
      label: 'Lexus ES250 2023 - JTHB11B17P2056676'
    },
    {
      value: 2152,
      label: 'Lexus ES250 2023 - JTHB11B10P2055661'
    },
    {
      value: 2153,
      label: 'Lexus ES350 2023 - JTHBZ1B18P2018897'
    },
    {
      value: 2155,
      label: 'Lexus ES350 2023 - JTHBZ1B12P2018992'
    },
    {
      value: 2182,
      label: ' - JTHB11B11P2055586'
    }
  ],
  message: 'Success ',
  meta: []
};
